import axios from "axios";
import i18n from "i18n";
import config from "../../../config";

const API_URL = config.TRAFFIC;

// helper that maps a numeric value to a color
const generateShades = (
  values,
  { hue = 200, sat = 70, lightMin = 30, lightMax = 80 } = {}
) => {
  const min = Math.min(...values);
  const max = Math.max(...values);
  return values.map((v) => {
    const norm = max === min ? 0.5 : (v - min) / (max - min);
    const lightness = lightMax - norm * (lightMax - lightMin);
    return `hsl(${hue}, ${sat}%, ${lightness}%)`;
  });
};

export const routeFlowsData = async (endpoint) => {
  try {
    const response = await axios.get(`${API_URL}${endpoint.endPoint}`, {
      headers: { "Accept-Profile": "traffic_monitoring" },
    });


    // Sort data: descending for Egnatia East, ascending for others
    const sortedData = response.data.sort((a, b) =>
      endpoint.name === "Egnatia East" ? b.id - a.id : a.id - b.id
    );

    // Safe values + labels
    const rawValues = sortedData.map(endpoint.computeValue);
    const values = rawValues.map((v) => (Number.isFinite(v) ? v : 0));
    const labels = sortedData.map((entry) => entry.name);

    // Dynamic colors
    const backgroundColor = generateShades(values, {
      hue: 200,
      sat: 70,
      lightMin: 30,
      lightMax: 80,
    });

    // Align lengths
    const N = Math.min(labels.length, values.length, backgroundColor.length);
    const safeLabels = labels.slice(0, N);
    const safeValues = values.slice(0, N);
    const safeBg = backgroundColor.slice(0, N);

    // Build dataset safely
    const datasets = [
      {
        label: i18n.t("trafficMonitoring.routeFlows.totalFlow"),
        data: safeValues,
        backgroundColor: safeBg,
        maxBarThickness: 30,
        borderWidth: 0,
      },
    ].filter((ds) => ds && Array.isArray(ds.data));

    // Chart options
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: true }, // legend on by default
        title: {
          display: true,
          text: endpoint.name,
          font: { size: 16 },
          color: "#fff",
        },
        datalabels: {
          anchor: "end",
          align: "end",
          offset: -4,
          formatter: (value) => value ?? "",
          font: { size: 12 },
          color: "#636363",
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: { display: false },
          grid: { display: false },
        },
      },
    };

    return {
      id: endpoint.name,
      data: { labels: safeLabels, datasets },
      options,
    };
  } catch (error) {
    console.error(`Error fetching data from ${endpoint.name}:`, error);
    return null;
  }
};
